module.exports = __webpack_public_path__ + "img/Webpage-icon.978bb164.svg";